import React from 'react';
import Lookup from 'src/componentes/select2';

const NivelEducacionalLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/NivelEducacionalLookup" {...rest} />;

export default NivelEducacionalLookup;
